import React, { useMemo } from 'react';
import { useTranslate } from '../../../core/translate';
import Compare from '../../common/compare/Compare';
import { removeKeys } from '../../utils/removeKeys';
import { getHeaderDataForStyle, getLowestPricedTrims } from './utils';
import { capitalize } from 'lodash';
import { useLocation } from 'react-router-dom';
import { compareModalScrollToRef } from './useCompareModalScrolling';

const analyticsKey = 'compare trims';

// TODO: Sort radio needs to show an indication when focused. Currently, no visible outline or focus indication is displayed when tabbed to.
const TrimCompare = ({
  features,
  config,
  selectedTrim,
  onSelect,
  onClose,
  trimGroups,
  isScrolled,
  isScrolledUp,
  setIsScrolledUp,
  isSelectionRevealed,
  keyFeatureSelections = [],
}) => {
  const { groups, styleIds: valuesByStyle } = features;
  const { search } = useLocation();
  const translate = useTranslate();

  const getTrims = (trims) => {
    return getLowestPricedTrims(trims);
  };

  const lowestPriceTrims = getTrims(trimGroups);

  const selectedIndex = +new URLSearchParams(search).get('selectedIndex') || 0;

  const headers = lowestPriceTrims.map((style) =>
    getHeaderDataForStyle(style, 'msrpText')
  );

  const hasFeatureSelections = keyFeatureSelections.length > 0;

  const addMatchingFeatureValues = (group) => {
    const highlightsKey = capitalize(
      translate('component.trim.compare.highlights')
    );

    if (hasFeatureSelections) {
      const { [highlightsKey]: highlights, ...restOfGroupKeys } = group;

      const flatGroupLK = removeKeys(group);

      return {
        ...(highlights && {
          [highlightsKey]: highlights,
        }),
        [translate('common.matching.key.features.v3')]: {
          ...keyFeatureSelections.reduce(
            (accum, feat) => ({ ...accum, [feat]: flatGroupLK[feat] }),
            {}
          ),
        },
        ...restOfGroupKeys,
      };
    }

    return group;
  };

  const columns = useMemo(() => {
    return lowestPriceTrims.map((style) => {
      return {
        data: style,
        groups: addMatchingFeatureValues(valuesByStyle[style.styleId]),
      };
    });
  }, [trimGroups]);

  const handleSelect = ({ data }) => {
    if (
      !isSelectionRevealed ||
      (selectedTrim && selectedTrim.styleId !== data.styleId)
    ) {
      onSelect(lowestPriceTrims.find((trim) => trim.styleId === data.styleId));
    }
    onClose();
  };

  const groupsWithMatching = useMemo(() => addMatchingFeatureValues(groups), [
    trimGroups,
  ]);

  return (
    <Compare
      headers={headers}
      columns={columns}
      compareGroups={groupsWithMatching}
      config={config}
      onSelect={handleSelect}
      isScrolled={isScrolled}
      isScrolledUp={isScrolledUp}
      setIsScrolledUp={setIsScrolledUp}
      analyticsKey={analyticsKey}
      selectedIndex={selectedIndex}
      scrollToSearchFeature={compareModalScrollToRef}
    />
  );
};

export default TrimCompare;
